import React, { useEffect } from 'react';
import Head from 'next/head';
import getMetaTagData from '../../src/common/services/getMetaTagData';
import { useRouter } from 'next/router';

function HotIssue({ metaTagData }) {
  const router = useRouter();

  useEffect(() => {
    //hotissue/all 로 이동 시키는 로직
    router.push('/hotissue/all');
  }, []); //화면시작시 최초 한번 시작...

  return (
    <>
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />
        <script src="//developers.kakao.com/sdk/js/kakao.min.js" />
        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>
    </>
  );
} //finish this viw function()

export async function getServerSideProps(ctx) {
  const { pageSection, pageCategory } = ctx.query;
  let metaTagData;
  try {
    metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
  } catch (error) {
    console.error(error);
  }
  return { props: { metaTagData } };
}

export default HotIssue;
